// src/components/Header.jsx
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { NAV } from "../utils/constants";
import logo from "../AM-Audio.PNG";

export default function Header() {
  const [open, setOpen] = useState(false);

  const linkClass = ({ isActive }) =>
    `navlink ${isActive ? "navlink--active" : ""}`;

  return (
    <header className="header-blur" style={{ position: "sticky", top: 0, zIndex: 40 }}>
      <a href="#main" className="sr-only" style={{ position: "absolute", left: -9999 }}>
        Skip to content
      </a>

      <nav aria-label="Primary" className="container-tight" style={{ padding: "12px 0" }}>
        <div className="space-between" style={{ gap: 12 }}>
          <div className="row-center" style={{ gap: 10 }}>
            <img src={logo} alt="A & M Audio logo" width="28" height="28" style={{ borderRadius: 8 }} />
            <NavLink to="/" className="h3" style={{ margin: 0, textDecoration: "none" }}>
              A &amp; M Audio
            </NavLink>
          </div>

          <div className="desktop-nav">
            <ul className="desktop-nav__list">
              {NAV.map((i) => (
                <li key={i.to}>
                  <NavLink to={i.to} className={linkClass}>
                    {i.label}
                  </NavLink>
                </li>
              ))}
            </ul>

            <a
              href="mailto:austinlm132@gmail.com?subject=A%20%26%20M%20Audio%20Install%20Request"
              className="btn btn-primary desktop-nav__cta"
            >
              Request Install (Email)
            </a>
          </div>

          <button
            className="btn btn-outline mobile-toggle"
            aria-expanded={open}
            aria-controls="site-nav"
            onClick={() => setOpen((v) => !v)}
          >
            {open ? "Close" : "Menu"}
          </button>
        </div>

        <ul
          id="site-nav"
          className="list-plain mobile-menu"
          style={{ display: open ? "block" : "none", marginTop: 12 }}
        >
          {NAV.map((i) => (
            <li key={i.to} style={{ padding: "6px 0" }}>
              <NavLink to={i.to} onClick={() => setOpen(false)} className={linkClass}>
                {i.label}
              </NavLink>
            </li>
          ))}

          <li style={{ marginTop: 8 }}>
            <a
              href="mailto:austinlm132@gmail.com?subject=A%20%26%20M%20Audio%20Install%20Request"
              onClick={() => setOpen(false)}
              className="btn btn-primary"
            >
              Request Install (Email)
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
}
